<template>
    <div>
        <h3 class="mb-0">{{ $t('descuentos_sga.titulo_cupon') }}</h3>
        <small>{{ $t('descuentos_sga.explicacion_cupon') }}</small>
        <div v-if="!cupon_aplicado || !cupon_valido" class="input-group mt-2 mb-2">
            <input
                class="form-control"
                id="input-cupon"
                v-model="cupon"
                :placeholder="$t('formularios.cupon_descuento')"
                :disabled="loading || loading_cupon"
            />
            <button
                :disabled="loading || loading_cupon || !cupon"
                :class="'button '+ (esMovil ? 'small-button' : 'large-button')"
                @click="handleCupon"
            >
                {{ $t('formularios.verificar') }}
            </button>
        </div>
        <div v-if="cupon_aplicado" class="mt-2 mb-2">
            <b-row>
                <b-col cols="12" md="8">
                    <div v-if="cupon_valido" class="alert alert-success d-flex justify-content-between align-items-center">
                        <div>
                            <i class="fas fa-ticket-alt"></i> &nbsp;
                            <strong>{{ this.cupon.toUpperCase() }}</strong>
                        </div>
                        <div>
                            <button
                                class="button badge bg-light text-danger py-2"
                                @click="desactivarCupon"
                                :disabled="loading || loading_cupon"
                            >
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                    <div v-else class="mt-2 mb-2">
                        <div class="alert alert-danger d-flex justify-content-between align-items-center">
                            <b>{{ mensaje }}</b>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cart_id: {
                type: Number,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            },
            esMovil: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                cupon: '',
                mensaje: '',
                loading_cupon: false,
                cupon_aplicado: false,
                cupon_valido: false
            }
        },
        methods: {
            async handleCupon() {
                this.loading_cupon = true

                const params = {
                    filters: {
                        codigo: this.cupon
                    },
                    cart_id: this.cart_id
                }

                try {
                    await this.$store.dispatch(this.config.getVuexAlias('sga.cart.descuentos-codigo'), params).then(res => {
                        if (res.data?.data?.limit === 0) {
                            this.mensaje = 'Cupón de descuento no disponible';
                        } else if (!res.data.data) {
                            this.cupon_aplicado = true;
                            this.cupon_valido = false;
                            this.mensaje = 'El cupón introducido no existe o no está disponible'
                        }
                        else {
                            this.cupon_aplicado = true;
                            this.cupon_valido = true;
                            this.$emit('setDescuento', res.data.data);
                            this.mensaje = '¡Cupón de descuento aplicado correctamente!';
                        }
                    });
                } catch (error) {
                    this.mensaje = 'El cupón introducido no existe o no está disponible';
                } finally {
                    this.loading_cupon = false;
                }
            },
            desactivarCupon() {
                this.cupon = '';
                this.cupon_aplicado = false;
                this.$emit('desactivarCuponGeneral', null);
            }
        }
    }
</script>